import config from '../config';
import LocalStorageHelper from './local_storage';

const AssetHelper = {
	/**
	 * 
	 * @returns {String}
	 */
	getActionUrl: () => {
		return `${config.api}/app/assets`;
	},

	/**
	 * 
	 * @param {String} id 
	 * @returns {String}
	 */
	getDownloadUrl: (id) => {
		const token = LocalStorageHelper.getToken();
		return `${config.api}/app/assets/id?id=${id}&t=${token}`;
	},
	/**
	 * 
	 * @returns {String}
	 */
	getHeader: () => {
		const token = LocalStorageHelper.getToken();
		return { 'Authorization': `Bearer ${token}` };
	},

	/**
	 * 
	 * @returns {Integer} bytes
	 */
	getMaxSize: () => {
		return 5242880; // 5 MB
	},

	/**
	 * 
	 * @returns {String} message
	 */
	getMaxSizeMsg: () => {
		return 'has exceeded the max file size of 5MB!';
	},

	getApplicationPdfDownloadUrl: (id) => {
		const token = LocalStorageHelper.getToken();
		return `${config.api}/app/applications/id/generate-pdf?id=${id}&t=${token}`;
	}
};

export default AssetHelper;
